module.exports = __webpack_public_path__ + "static/media/Quotation.035f83ef.png";